import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './style.css';

/*
 * Нативного loading="lazy" тут не досить: Chrome вантажить усе, що ближче
 * ~1250px до вікна, а на цій сітці це 15 обкладинок і 14 МБ одразу після
 * відкриття сторінки. Спостерігач проставляє src лише коли картка підійшла
 * на 200px до вікна, тож ваги додає тільки те, що людина справді догортала.
 * Місце під картинку тримає aspect-ratio у style.css — сітка не стрибає,
 * поки src ще не проставлено.
 */
const Project = ({ title, img, index }) => {
	const imgRef = useRef(null);
	const [inView, setInView] = useState(false);

	useEffect(() => {
		const el = imgRef.current;
		if (!el) return;

		// Браузер без IntersectionObserver отримує стару поведінку,
		// а не порожні картки.
		if (typeof IntersectionObserver === 'undefined') {
			setInView(true);
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					setInView(true);
					observer.disconnect();
				}
			},
			{ rootMargin: '200px' }
		);

		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return (
		<li className="project">
			<NavLink to={`/project/${index}`}>
				<img
					ref={imgRef}
					src={inView ? img : undefined}
					alt={title}
					className="project__img"
					loading="lazy"
					decoding="async"
				/>
				<h3 className="project__title">{title}</h3>
			</NavLink>
		</li>
	);
};

export default Project;
